import styled from 'styled-components';
import { devices, renderStyledElementStyles } from '../../../../helpers';

export const SectionWrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.section)}

  &&& {
    @media only screen and (max-width: ${devices.breakpoints.tablet}) {
      > .container {
        padding: 0;

        > .row {
          margin: 0;

          > [class^='col-'] {
            padding: 0;
          }
        }
      }
    }
  }
`;
